import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, unexpectedError, filter, showingPageTotalRange } from '../../../common_functions';

const LocationList = props => {
  const [locations, setLocations] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Collection',
      dataIndex: 'collections.name',
      key: 'collections.name',
      sorter: true,
      render: (text, record) => {
        return <>{record?.collections?.name}</>;
      },
      ...filter('collections'),
    },
    {
      title: 'Site',
      dataIndex: 'site',
      key: 'site',
      sorter: true,
      ...filter('site'),
    },
    {
      title: 'Room',
      dataIndex: 'room',
      key: 'room',
      sorter: true,
      ...filter('room'),
    },
    {
      title: 'Shelf',
      dataIndex: 'shelf',
      key: 'shelf',
      sorter: true,
      ...filter('box'),
    },
    {
      title: 'Box',
      dataIndex: 'box',
      key: 'box',
      sorter: true,
      ...filter('box'),
    },
    {
      title: 'Location Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ...filter('name'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/object-locations/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_locations?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_locations?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'location',
              'Location?',
              locations,
              setLocations,
              props?.tabs_permissions?.settings_locations?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getLocationsData(pagination);
  })();
  }, []);

  const getLocationsData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const { meta, data } = await props.getItems('location', {
        fields: ['id', 'collections.name', 'site', 'room', 'shelf', 'box', 'name'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = meta.filter_count;
      setPagination(pagination);
      setLocations(data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];

        val &&
          (key == 'collections.name'
            ? (filtersitems['collections'] = { name: { _icontains: val[0] } })
            : (filtersitems[key] = { _icontains: val[0] }));
      }
    }
    await getLocationsData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/object-locations" }, { title: "Object Locations" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Object Locations
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_locations,
                `/settings/object-locations/new`,
                'Create Object Location'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={locations}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default LocationList;
